    let autocomplete;
    let address1Field;
    let address2Field;
    let postalField;
    let stateField;

    const countryToCode = {
        bahrain: "BH",
        canada: "CA",
        china: "CN",
        "hong kong": "HK",
        japan: "JP",
        kuwait: "KW",
        oman: "OM",
        qatar: "QA",
        "saudi arabia": "SA",
        singapore: "SG",
        "south korea": "KR",
        taiwan: "TW",
        "united arab emirates (uae)": "AE",
        "united states of america": "US"
    };
    

    document.addEventListener("DOMContentLoaded", function() {
        document.querySelector("#country").addEventListener("change", function() {
            setCountry(this.value);
        });
        initAutocomplete(); // Initialiser Autocomplete après l'ajout de l'écouteur d'événements
    });
    

    function initAutocomplete() {
        address1Field = document.querySelector("#address_1");
        address2Field = document.querySelector("#address_2");
        postalField = document.querySelector("#zipcode");
        stateField = document.querySelector("#state");
    
        // Récupérer le pays actuellement sélectionné
        let selectedCountry = document.querySelector("#country").value;
        setCountry(selectedCountry);
        address1Field.focus();
    }
    
    

    function fillInAddress() {
        // Get the place details from the autocomplete object.
        const place = autocomplete.getPlace();
        let address1 = "";
        let route = ""; 
        let street_number = "";
        let postcode = "";
        let political = "";
        let sublocality = "";
        let sublocality_lv2 = "";
        let sublocality_lv3 = "";
        let sublocality_lv4 = "";
        let city = "";
        let premise = "";
        let state = "";
    
        // Iterate through each component of the address
        for (const component of place.address_components) {
            const componentType = component.types[0];
    
            switch (componentType) {
                case "street_number":
                    street_number = component.long_name;
                    break;
                case "premise":
                    premise = component.long_name;
                    break;
                case "route":
                    route = component.long_name;
                    break;
                case "postal_code":
                    postcode = component.long_name;
                    break;
                case "postal_code_suffix":
                    postcode = `${postcode}-${component.long_name}`;
                    break;
                case "locality":
                    city = component.long_name;
                    document.querySelector("#city").value = component.long_name;
                    break;
                case "political":
                    political = component.long_name;
                    break;
                case "sublocality_level_1":
                    sublocality = component.long_name;
                    break;
                case "sublocality_level_2":
                    sublocality_lv2 = component.long_name;
                    break;
                case "sublocality_level_3":
                    sublocality_lv3 = component.long_name;
                    break;
                case "sublocality_level_4":
                    sublocality_lv4 = component.long_name;
                    break;
                case "administrative_area_level_1":
                    administrative_area = component.long_name;
                    // state = component.long_name;
                    state = component.short_name;
                    document.querySelector("#state").value = state;
                    break;
            }
        }

        console.log([street_number, route, postcode, state, city, political, sublocality, administrative_area])

        if(!street_number){
            street_number = premise;
        }
        if(!route){
            if(sublocality_lv4){
                if(route){route += ", ";}
                route += sublocality_lv4;
                console.log(["sublocality_lv4", sublocality_lv4])
            }
            if(sublocality_lv3){
                if(route){route += ", ";}
                route += sublocality_lv3;
                console.log(["sublocality_lv3", sublocality_lv3])
            }
            if(sublocality_lv2){
                if(route){route += ", ";}
                route += sublocality_lv2;
                console.log(["sublocality_lv2", sublocality_lv2])
            }
            if(sublocality){
                if(route){route += ", ";}
                route += sublocality;
                console.log(["sublocality", sublocality])
            }
        }
        address1 = `${street_number} ${route}`;

        if(!city){
            city = administrative_area;
            document.querySelector("#city").value = city;
        }    

        address1Field.value = address1.trim(); 
        console.log(address1.trim())
        postalField.value = postcode;
        address2Field.focus();
        stateField.value = state;
    }    

    function setCountry(countryName) {
        const countryCode = countryToCode[countryName.toLowerCase()] || 'US'; 
        if (autocomplete) {
            autocomplete.unbindAll(); 
        }
        autocomplete = new google.maps.places.Autocomplete(address1Field, {
            componentRestrictions: { country: [countryCode] },
            fields: ["address_components", "geometry"],
            types: ["address"],
        });
        autocomplete.addListener("place_changed", fillInAddress);
        console.log(`Autocomplete reloaded for country: ${countryName} (${countryCode})`, autocomplete);
    }    
    

    window.initAutocomplete = initAutocomplete;
